module.exports = __webpack_public_path__ + "27b93e96f131d58020af1a2280339840.pdf";